/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// libraries
import { useDebounce } from 'use-lodash-debounce';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Grid, Box, Card, Typography, MenuItem, Alert, List, ListItemButton, ListItemText, ListItemIcon } from '@mui/material';
// components
import { debounce } from 'lodash';
import { useSnackbar } from 'notistack';
import TreatmentEditPopover from '../../pages/dashboard/tables/AllLeadTable/TreatmentEditPopover';
import UserSearchDropdown from '../UserSearchDropdown';
import TreatmentFlowComponent from '../treatmentComponents/TreatmentFlowComponent';
import Iconify from '../Iconify';
import { FormProvider, RHFTextField, RHFRadioGroup, RHFSelect } from '../hook-form';
import CustomRadioGroupComponent from '../followup-callScript/CustomRadioGroupComponent';
import CustomLeadInquiryFields from '../followup-callScript/CustomLeadInquiryFields';
import CustomScriptMobileDatePicker from '../followup-callScript/CustomScriptMobileDatePicker';
import ScriptDateTimePicker from '../followup-callScript/ScriptDateTimePicker';
import CustomCombinedFields from '../followup-callScript/CustomCombinedFields';
import CustomLeadNameAutocomplete from '../followup-callScript/CustomLeadNameAutocomplete';
import { CustomAdressComponent, CustomCheckboxComponent, CustomMultiSelectComponent, CustomDropdownComponent, CustomDescriptionComponent, CustomLabelComponent, CustomTitleComponent } from '../followup-callScript';
import SingleScriptHeader from './SingleScriptHeader';
// store
import { dispatch, useSelector } from '../../redux/store';
import { UpdateTreatmentV3, addNewLead, addTreatment, clearTaskLead, updateAssignToUser } from '../../redux/slices/lead';
import { createSubmission, getCallScriptSection, updateSubmission } from '../../redux/slices/callScript';
// utils/hooks/validation
import capitalizeFirstLetter from '../../utils/capitalizedFunc';
import { useAddTreatment, useAuth } from '../../hooks';
import { createDefaultValues, formatLeadData, formatLeadDetails, formatLeadTreatment, handleAddressData, handleLeadTypeData, handleSearch, handleSuccessMessage, handleTreatmentFunc, inboundSubmissionFunc, numberKeyDownFunc, saveTreatmentFunc, searchLeadFunc, searchLeadHandler, templateRenderFunc } from '../../utils/callScriptCommonFunc';
import { amountHandleChangeFunc, treatmentTeethFunc } from '../../utils/callScriptCommonFuncNew';
import { SingleScriptPreviewSchema } from '../../validations/validations';
// style
import { common } from '../../theme/palette';
import { gridStyle } from '../../styles/AddAppointmentStyle';
import { unableContactButtonStyle, loaderButtonStyle, testFieldWrapperStyle } from '../../styles/CallScripts';

const DefaultScriptView = ({ onClose, scriptData, backButtonClick }) => {
    const { user } = useAuth();
    const [expand, setExpand] = useState(false);
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const { callScriptData } = useSelector((state) => state.callScript);
    const [fieldData, setFieldData] = useState([]);
    const [tempFieldData, setTempFieldData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const { taskSearchLead } = useSelector((state) => state.lead);
    const debouncedValue = useDebounce(searchQuery, 1000);
    const { referral } = useSelector((state) => state.schema);
    const referralValue = (value, data) => referral?.length > 0 && referral?.filter((res) => res[value] === data.referral);
    const [newtreatmentData, setNewTreatment] = useState('');
    const [leadTreatment, setLeadTreatment] = useState('');
    const [leadTreatmentValue, setLeadTreatmentValue] = useState('');
    const [leadTreatmentTeethValue, setLeadTreatmentTeethValue] = useState(null);
    const [assignToState, setAssignToState] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [anchorEditTreatment, setAnchorEditTreatment] = useState(null);
    const [priceAmountError, setPriceAmountError] = useState(false);
    const [teethAmountError, setTeethAmountError] = useState(false);
    const InboundScripts = callScriptData?.results?.filter((el) => el.category === 'INBOUND');
    const [selectedFormId, setSelectedFormId] = useState('');
    const mergeTags = useSelector((state) => state.mergeTags);

    useEffect(() => {
        if (scriptData?.sections) {
            setFieldData(scriptData?.sections);
            setSelectedFormId(scriptData?.formId);
            formIdRef.current = scriptData?.formId;
        }
    }, [scriptData]);

    useEffect(() => {
        if (newtreatmentData && InboundScripts?.length === 1) {
            templateRenderFunc({ value: InboundScripts?.[0]?.id, setValue, InboundScripts, setSelectedFormId, setTempFieldData, fieldData });
        }
        if (newtreatmentData && (InboundScripts?.length > 1 || InboundScripts?.length === 0)) {
            setTempFieldData([]);
            setValue('template', null);
        }
    }, [newtreatmentData, callScriptData]);

    const {
        toggle: EditTreatment,
        onOpen: onEditTreatment,
        onClose: onCloseEditTreatment
    } = useAddTreatment();

    useEffect(() => {
        handleSearch(searchQuery);
    }, [debouncedValue]);

    useEffect(() => {
        if (searchQuery?.length === 0) {
            dispatch(clearTaskLead());
        }
    }, [taskSearchLead]);

    const defaultValues = createDefaultValues(user);

    const methods = useForm({
        resolver: yupResolver(SingleScriptPreviewSchema([...fieldData, ...tempFieldData])),
        defaultValues,
        shouldFocusError: false,
    });

    const {
        control,
        setValue,
        handleSubmit,
        formState: { errors },
        watch,
        clearErrors,
        getValues
    } = methods;

    const values = watch();

    const formRef = React.useRef({ inProgress: false, formId: null });
    const formIdRef = React.useRef(null);
    const { enqueueSnackbar } = useSnackbar();

    const setFormState = (newState) => {
        formRef.current = { ...formRef.current, ...newState };
    };

    useEffect(() => {
        setFormState({ inProgress: false, formId: null });
    }, [])

    const hideLoader = () => {
        setTimeout(() => { setSubmitLoading(false); }, 2000);
    };

    const onSubmit = (data, type) => {
        setSubmitLoading(true);
        if (data.leadName !== undefined) {
            const leadData = formatLeadData(data, assignToState);
            const leadUpdateData = formatLeadData(data, [], true);
            handleLeadTypeData({ data, leadData, leadUpdateData });
            handleAddressData({ data, leadData, leadUpdateData });
            const detail = formatLeadTreatment(data);
            hideLoader();
            if (data.bookedWith) {
                dispatch(updateAssignToUser(leadData, data?.lead_id, practiceId, handleSuccess, type, 'leadUpdate'));
            } else {
                dispatch(updateAssignToUser(leadUpdateData, data?.lead_id, practiceId, handleSuccess, type, 'leadUpdate'));
            }
            if (detail.treatment !== leadTreatment || detail.custom_price !== leadTreatmentValue || detail.teethAmount !== leadTreatmentTeethValue) {
                if (data?.treatment_id === undefined) {
                    dispatch(addTreatment(detail, practiceId, data?.lead_id, handleSuccess, { needToUpdate: detail.teethAmount || detail.teethAmount === 0, teeth: detail.teethAmount || 0 }));
                } else {
                    dispatch(UpdateTreatmentV3({ detail, lead_id: data?.lead_id, treatment_id: data?.treatment_id }, type, handleSuccess));
                }
            }
        } else {
            const leadDetails = formatLeadDetails(data);
            if (data.title) {
                leadDetails.salutation = data.title && data.title.toUpperCase();
            }
            if (data.bookedWith) {
                leadDetails.assignees = assignToState?.map((el) => el?.id) || [];
            }
            if (data.preferredContactMethod) {
                leadDetails.lead_contact = {
                    ...leadDetails.lead_contact,
                    preferred_contact_method: data.preferredContactMethod?.toUpperCase()
                };
            }
            const addressFields = ['address_line_1', 'address_line_2', 'postcode', 'city', 'county'];
            addressFields.forEach(field => {
                if (data[field]) {
                    leadDetails.lead_address = {
                        ...leadDetails.lead_address,
                        [field]: data[field]
                    };
                }
            });
            const sourceFields = ['leadType', 'referral'];
            sourceFields.forEach(field => {
                if (data[field]) {
                    leadDetails.lead_source = {
                        ...leadDetails.lead_source,
                        [field]: data[field]
                    };
                    if (field === 'referral' && data[field] === "CLINICIAN") {
                        leadDetails.lead_source = {
                            ...leadDetails.lead_source,
                            affiliate_user: data.affiliate_user,
                            type: "CLINICIAN"
                        };
                    }
                }
            });
            const treatmentDetail = formatLeadTreatment(data);
            dispatch(addNewLead(leadDetails, practiceId, treatmentDetail, data, handleSuccess, type));
            hideLoader();
            return;
        }
        if (!formRef?.current?.formId)
            inboundSubmissionFunc({ data, fieldData: [...fieldData, ...tempFieldData], handleSuccess, selectedFormId });
        else
            autoSave(type, handleSuccess)
    };

    const handleSuccess = (data) => {
        hideLoader();
        if (data?.leadUpdate) {
            handleSuccessMessage({ data });
        }
        if (data?.success) {
            onClose();
        }
        if (data.leadId) {
            if (!formRef?.current?.formId)
                inboundSubmissionFunc({ data: data.formData, fieldData: [...fieldData, ...tempFieldData], handleSuccess, selectedFormId, leadId: data.leadId });
            else
                autoSave(null, () => { })
        }
        if (data.updateTreatment) {
            handleSuccessMessage({ data });
        }
    };

    const autoSave = async (type = "autosave", handleSuccess = null) => {
        const formData = getValues();  // Get current form data without triggering validation
        try {

            const textKeys = Object.entries(formData).filter(key => key);
            const fieldDataArray = [...fieldData, ...tempFieldData]?.flatMap(data => data?.fields?.map(field => field));
            const fieldDataWithValue = textKeys?.filter((el) => fieldDataArray.some((sx) => sx?.id?.toString().includes(el[0]?.split('_')[1]) ? { fields: sx?.field_type?.id, value: el[1] } : ''));
            const submissionData = {
                practice: Number(practiceId),
                lead: formData?.lead_id,
                formId: formIdRef.current,
                fields: formRef?.current?.formId ?
                    fieldDataWithValue?.map((el) => ({ field: Number(el[0]?.split('_')[1]), value: Array.isArray(el[1]) ? el[1].join(' | ') : el[1], ...(formRef.current?.fieldMap?.[Number(el[0]?.split('_')[1])] ? { id: formRef.current?.fieldMap?.[Number(el[0]?.split('_')[1])] } : {}) })) :
                    fieldDataWithValue?.map((el) => ({ field: Number(el[0]?.split('_')[1]), value: Array.isArray(el[1]) ? el[1].join(' | ') : el[1] }))
            };
            if (!formRef.current?.inProgress && !formRef.current?.formId) {
                setFormState({ inProgress: true });
                dispatch(createSubmission(submissionData, (payload) => {
                    if (handleSuccess) {
                        handleSuccess(payload);
                        return;
                    }
                    const { success, data } = payload;
                    if (success) {
                        const fieldMap = {};
                        data?.fields?.forEach(field => {
                            fieldMap[field?.field] = field?.id;
                        })
                        setFormState({ formId: data?.id, inProgress: false, date: Date.now(), formData: data, fieldMap });
                        enqueueSnackbar('Auto Saved Call Script Form', {
                            variant: 'success',
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            }
                        });
                    }
                }, type));
            } else if (formRef?.current?.formId) {
                setFormState({ inProgress: true });
                dispatch(updateSubmission(practiceId, formIdRef.current, formRef?.current?.formId, submissionData, (payload) => {
                    if (handleSuccess) {
                        handleSuccess(payload);
                        return;
                    }
                    const { success } = payload;
                    if (success) {
                        setFormState({ inProgress: false, date: Date.now() });
                        enqueueSnackbar('Auto Saved Call Script Form', {
                            variant: 'success',
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            }
                        });
                    }
                }, type));
            } else {
                setFormState({ inProgress: false });
            }
            if (!handleSuccess) {
                const data = formData;
                if (data.leadName !== undefined) {
                    const leadData = formatLeadData(data, assignToState);
                    const leadUpdateData = formatLeadData(data, [], true);
                    handleLeadTypeData({ data, leadData, leadUpdateData });
                    handleAddressData({ data, leadData, leadUpdateData });
                    const detail = formatLeadTreatment(data);
                    if (data.bookedWith) {
                        dispatch(updateAssignToUser(leadData, data?.lead_id, practiceId, () => { }, type, 'leadUpdate'));
                    } else {
                        dispatch(updateAssignToUser(leadUpdateData, data?.lead_id, practiceId, () => { }, type, 'leadUpdate'));
                    }
                    if (detail.treatment !== leadTreatment || detail.custom_price !== leadTreatmentValue || detail.teethAmount !== leadTreatmentTeethValue) {
                        if (data?.treatment_id === undefined) {
                            dispatch(addTreatment(detail, practiceId, data?.lead_id, () => { }, { needToUpdate: detail.teethAmount || detail.teethAmount === 0, teeth: detail.teethAmount || 0 }));
                        } else {
                            dispatch(UpdateTreatmentV3({ detail, lead_id: data?.lead_id, treatment_id: data?.treatment_id }, type, () => { }));
                        }
                    }
                }
            }
        } catch (error) {
            console.error("Auto-save failed", error);
        }
    };

    const debouncedAutoSave = useCallback(
        debounce(() => autoSave(), 1000),
        []
    );

    useEffect(() => {
        const subscription = watch(() => debouncedAutoSave());
        return () => subscription.unsubscribe();  // Cleanup on unmount
    }, [watch]);

    const handleReferral = (event, data) => {
        setValue('referral', data?.id ? "CLINICIAN" : data?.value);
        if (data?.id) {
            setValue('affiliate_user', data?.id);
            setValue('type', "CLINICIAN");
        }
    };

    const handleSaveTreatment = (data) => {
        saveTreatmentFunc({ setNewTreatment, setValue, data });
        setTempFieldData([]);
        setValue('template', null);
        onCloseEditTreatment();
        dispatch(getCallScriptSection({ practiceId, treatment: data.selectedTreatment || '', isTemplate: false, category: 'INBOUND' }));
    };

    const [dataMap, setDataMap] = React.useState({});

    React.useEffect(() => {
        setDataMap(prv => ({ ...prv, ...(mergeTags?.mtValPractice ?? {}), ...(mergeTags?.mtValUser ?? {}) }))
        if (!mergeTags?.mtValLoadingLeads && !mergeTags?.mtValLoadingTreatments) {
            setDataMap(prv => ({ ...prv, ...(mergeTags?.mtValTreatments ?? {}), ...(mergeTags?.mtValLeads ?? {}) }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mergeTags?.mtValLoadingLeads, mergeTags?.mtValLoadingTreatments]);


    const parseMergeTags = (datalabels) => (
        // Use regex to find all words starting with '$' followed by alphanumeric characters or underscores
        datalabels?.replace(/\$[a-zA-Z0-9_]+/g, (match) => {
            // Remove the '$' sign to get the actual key
            const key = match.slice(1);

            // Return the value from the dataMap if it exists, otherwise return the original field
            return Object.prototype.hasOwnProperty.call(dataMap, key) ? dataMap[key] : match;
        }) ?? datalabels);

    const getFieldLabel = useCallback((name) => {
        if (!name) return '';
        const specialMap = {
            firstName: 'First Name',
            lastName: 'Last Name',
            leadName: 'Lead',
            lead_id: 'Lead',
            type: 'Type',
            leadType: 'Lead Type',
            phone_number: 'Phone Number',
            email: 'Email',
            dob: 'Date of Birth',
            treatment: 'Treatment',
            treatment_id: 'Treatment',
            treatmentValue: 'Treatment Value',
            teethAmount: 'Teeth Amount',
            referral: 'Referral',
            bookedWith: 'Assigned To',
            title: 'Title',
            isRegister: 'Is Registered Patient',
            preferredContactMethod: 'Preferred Contact Method',
            address_line_1: 'Address Line 1',
            address_line_2: 'Address Line 2',
            city: 'City',
            county: 'County',
            postcode: 'Postcode',
            address: 'Address Search',
        };
        if (specialMap[name]) return specialMap[name];
        const parts = name.split('_');
        if (parts.length > 1) {
            const id = parseInt(parts[1], 10);
            if (!Number.isNaN(id)) {
                const allFields = [...(fieldData || []), ...(tempFieldData || [])]?.flatMap((s) => s?.fields || []) || [];
                const fld = allFields.find((f) => f?.id === id);
                if (fld) return fld?.label || fld?.field_type?.name || name;
            }
        }
        return name.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    }, [fieldData, tempFieldData]);

    const onInvalid = useCallback((formErrors) => {
        try {
            const entries = Object.entries(formErrors || {});
            if (entries.length) {
                entries.forEach(([fieldName, err]) => {
                    const label = getFieldLabel(fieldName);
                    const message = err?.message || 'Invalid value';
                });
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log('Validation failed but could not parse errors');
        }
    }, [getFieldLabel]);

    const scrollToField = useCallback((fieldName) => {
        if (!fieldName) return;

        const tryFind = (name) => document.querySelector(`[name="${name}"]`) || document.querySelector(`[data-field-name="${name}"]`);

        let el = tryFind(fieldName);

        // Fallbacks for common virtual/derived names
        if (!el) {
            // Treatment block fallback
            if (fieldName === 'treatmentValue' || fieldName === 'treatment') {
                el = tryFind('treatmentValue') || tryFind('treatment');
            }

            // Explicit mapping for structured address fields
            if (!el && ['address_line_1', 'address_line_2', 'city', 'county', 'postcode', 'address'].includes(fieldName)) {
                el = tryFind('address');
            }

            // Map dynamic field names like char_123 to their UI anchors using field metadata
            if (!el && fieldName.includes('_')) {
                const parts = fieldName.split('_');
                const id = parseInt(parts[1], 10);
                if (!Number.isNaN(id)) {
                    const allFields = [...(fieldData || []), ...(tempFieldData || [])]?.flatMap((s) => s?.fields || []) || [];
                    const fld = allFields.find((f) => f?.id === id);
                    if (fld?.field_type?.attribute === 'lead_address') {
                        el = tryFind('address');
                    }
                }
            }
        }

        if (el && typeof el.scrollIntoView === 'function') {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const focusTarget = el.matches('input,select,textarea,button') ? el : el.querySelector('input,select,textarea,button');
            if (focusTarget && typeof focusTarget.focus === 'function') {
                focusTarget.focus({ preventScroll: true });
                // Highlight the MUI input container to respect border radius
                const container = focusTarget.closest('.MuiOutlinedInput-root, .MuiInputBase-root, .MuiFormControl-root, .MuiTextField-root') || focusTarget;
                const prevBoxShadow = container.style.boxShadow;
                container.style.boxShadow = '0 0 0 2px rgba(211, 47, 47, 0.5)';
                setTimeout(() => { if (container) container.style.boxShadow = prevBoxShadow; }, 1500);
            }
        }
    }, [fieldData, tempFieldData]);

    const RenderFieldItem = (item) => (
        <>
            {
                item.fields?.length > 0 && <Box sx={{ mb: '30px', borderBottom: `1px solid ${common.platinum}`, pb: '8px' }}>
                    <Typography sx={{ fontSize: '22px' }}>{item.name}</Typography>
                </Box>
            }
            {
                item.fields.map((_data, index) => {
                    const data = { ..._data };
                    data.label = parseMergeTags(data?.label);
                    data.description = parseMergeTags(data?.description);
                    return (
                        <Box sx={{ mb: '30px' }} key={index}>
                            {data?.field_type && <CustomTitleComponent data={data} defaultValues={defaultValues} />}
                            {data?.field_type?.field_type === 'text' && <>
                                <CustomDescriptionComponent description={data.description} />
                                {data?.field_type?.is_name_visible && <CustomLabelComponent data={data} />}
                                <RHFTextField name={`text_${[data.id]}`} multiline rows={5} />
                            </>}
                            {data?.field_type?.field_type === 'label' && <>
                                {data?.field_type?.is_name_visible && <CustomLabelComponent data={data} />}
                            </>}
                            {data?.field_type?.field_type === 'lead_search_select' && <>
                                <CustomDescriptionComponent description={data.description} />
                                {data?.field_type?.attribute === 'lead_search' &&
                                    <>
                                        {data?.field_type?.is_name_visible && <CustomLabelComponent data={data} />}
                                        <CustomLeadNameAutocomplete
                                            control={control}
                                            handleSearchLead={(e, value) => searchLeadFunc({ value, setValue, setSearchQuery, clearErrors, getCallScriptSection, setLeadTreatmentValue, setLeadTreatmentTeethValue, setNewTreatment, setLeadTreatment, setAssignToState })}
                                            searchLeadHandler={(event, value, reason) => searchLeadHandler(value, reason, setSearchQuery)}
                                            searchQuery={searchQuery}
                                        />
                                        <CustomCombinedFields />
                                    </>
                                }
                            </>}
                            {data?.field_type?.field_type === 'practice_treatment_search_select' && <>
                                {data?.field_type?.attribute === 'treatment_search' && <>
                                    {data?.field_type?.is_name_visible && <CustomLabelComponent data={data} />}
                                    <Grid container spacing={1} sx={{ ...gridStyle('callScript'), display: 'flex', m: '10px 0 16px' }} data-field-name={'treatment'}>
                                        {EditTreatment && (
                                            <TreatmentEditPopover
                                                treatment={newtreatmentData || ''}
                                                leadTreatmentSpecification={{ teeth_count: values.teethAmount }}
                                                open={EditTreatment}
                                                anchorEl={anchorEditTreatment}
                                                handleClickAwayLister={() => onCloseEditTreatment()}
                                                treatmentPrice={values.treatmentValue}
                                                handleSaveTreatment={handleSaveTreatment}
                                                isFlow
                                            />
                                        )}
                                        <TreatmentFlowComponent
                                            treatmentData={newtreatmentData}
                                            teethAmount={values.teethAmount}
                                            handleTreatment={(event) => handleTreatmentFunc({ onEditTreatment, setAnchorEditTreatment, event })}
                                            amount={values.treatmentValue}
                                            amountError={priceAmountError}
                                            amountHandleChange={(value) => amountHandleChangeFunc({ value, setValue, setPriceAmountError })}
                                            handleChangeTeeth={(e) => treatmentTeethFunc({ e, setValue, setTeethAmountError })}
                                            teethAmountError={teethAmountError}
                                        />
                                    </Grid>
                                </>}
                            </>}
                            {data?.field_type?.field_type === 'practice_user_search_select' && <>
                                {data?.field_type?.attribute === 'user_search' &&
                                    <>
                                        {data?.field_type?.is_name_visible && <CustomLabelComponent data={data} />}
                                        <UserSearchDropdown
                                            name={'bookedWith'}
                                            control={control}
                                            placeholder='Assign to'
                                            sx={{ mt: '10px' }}
                                            assignToState={assignToState}
                                            setAssignTo={setAssignToState}
                                        />
                                    </>
                                }
                            </>}
                            {data?.field_type?.field_type === 'char' && <>
                                <CustomDescriptionComponent description={data.description} />
                                {data?.field_type?.is_name_visible && <CustomLabelComponent data={data} />}
                                {(data?.field_type?.attribute !== 'phone' && data?.field_type?.attribute !== 'lead_email' && data?.field_type?.attribute !== 'lead_address') && <RHFTextField
                                    name={`char_${[data.id]}`}
                                    inputProps={{ maxLength: data?.field_type?.max_length }}
                                />}
                                {data?.field_type?.attribute === 'phone' && <>
                                    <Box sx={testFieldWrapperStyle}>
                                        <RHFTextField
                                            name={'phone_number'}
                                            type='string'
                                            inputProps={{ maxLength: 15 }}
                                            onKeyDown={(evt) => numberKeyDownFunc(evt)}
                                        />
                                    </Box>
                                </>}
                                {data?.field_type?.attribute === 'lead_email' && <>
                                    <Box sx={testFieldWrapperStyle}>
                                        <RHFTextField name={'email'} />
                                    </Box>
                                </>}
                                {data?.field_type?.attribute === 'lead_address' && <>
                                    <CustomAdressComponent control={control} setValue={setValue} values={values} />
                                </>}
                            </>}
                            {data?.field_type?.field_type === 'boolean' && <>
                                <CustomDescriptionComponent description={data.description} />
                                {data?.field_type?.is_name_visible && <CustomLabelComponent data={data} />}
                                <RHFRadioGroup
                                    name={`boolean_${[data.id]}`}
                                    options={[
                                        { label: 'Yes', value: 'yes' },
                                        { label: 'No', value: 'no' },
                                    ]}
                                    size='small'
                                    sx={{ margin: '-6px 2px 0', width: '100%' }}
                                />
                            </>}
                            {data?.field_type?.field_type === 'choice' && <>
                                <CustomDescriptionComponent description={data.description} />
                                {data?.field_type?.is_name_visible && <CustomLabelComponent data={data} />}
                                {data?.field_type?.attribute !== 'lead_source_type' && <>
                                    {data?.field_type?.ui_type === 'DROPDOWN' && <CustomDropdownComponent data={data} />}
                                    {data?.field_type?.ui_type === 'MULTI_SELECT' &&
                                        <CustomMultiSelectComponent data={data} methods={methods} />
                                    }
                                    {data?.field_type?.ui_type === 'CHECKBOX' && (
                                        <CustomCheckboxComponent methods={methods} data={data} />
                                    )}
                                    <CustomRadioGroupComponent methods={methods} data={data} />
                                </>}
                                <CustomLeadInquiryFields values={values} data={data} handleChange={(event, data) => setValue(data, event.target.value)} handleReferral={handleReferral} referralValue={referralValue} affiliate_user={values?.affiliate_user} />
                            </>}
                            {data?.field_type?.field_type === 'datetime' && <>
                                <CustomDescriptionComponent description={data.description} />
                                {data?.field_type?.is_name_visible && <CustomLabelComponent data={data} />}
                                <ScriptDateTimePicker data={data} />
                                <CustomScriptMobileDatePicker data={data} control={control} />
                            </>}
                        </Box>
                    )
                })
            }
        </>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit, onInvalid)}>
                <Card sx={{ maxWidth: expand ? '100%' : '1000px', mx: 'auto' }}>
                    <SingleScriptHeader
                        backButtonClick={backButtonClick}
                        expand={expand}
                        setExpand={setExpand}
                    />
                    <Box sx={{ p: '24px 24px 0' }}>
                        {fieldData?.map((item, index) => (
                            <Box sx={{ mb: '30px' }} key={index}>{RenderFieldItem(item, index)}</Box>
                        ))}
                        {newtreatmentData && InboundScripts?.length > 1 && <RHFSelect
                            name='template'
                            label='Select Template'
                            SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
                            onChange={(e) => templateRenderFunc({ value: e.target.value, setValue, InboundScripts, setSelectedFormId, setTempFieldData, fieldData })}
                            sx={{ mb: '30px', '.MuiOutlinedInput-notchedOutline': { borderColor: 'common.slateGray' } }}
                        >
                            {InboundScripts && InboundScripts.map((item, index) => (
                                <MenuItem value={item.id} key={index}>{capitalizeFirstLetter(item.name)}</MenuItem>
                            ))}
                        </RHFSelect>}
                        {tempFieldData?.map((item, index) => (
                            <Box sx={{ mb: '30px' }} key={index}>{RenderFieldItem(item, index)}</Box>
                        ))}
                    </Box>
                    <Box sx={{ p: '16px 24px 24px', display: 'flex', justifyContent: 'center' }}>
                        <LoadingButton type='submit' variant='contained' sx={unableContactButtonStyle} loading={submitLoading} loadingPosition='start'>
                            <Iconify style={loaderButtonStyle(submitLoading)} icon={'formkit:submit'} width={20} height={20} /> Submit
                        </LoadingButton>
                    </Box>
                    {Object.keys(errors).length > 0 && (
                        <Box sx={{ px: 3, pb: 3 }}>
                            <Alert
                                severity='error'
                                sx={{
                                    alignItems: 'flex-start',
                                    width: '100%',
                                    '& .MuiAlert-message': { width: '100%', p: 0 },
                                    '& .MuiAlert-icon': { mt: '2px' },
                                }}
                            >
                                <Typography sx={{ fontWeight: 600, mb: 0.5 }}>Please fill the required fields</Typography>
                                <Typography variant='caption' sx={{ opacity: 0.8, mb: 1, display: 'block' }}>
                                    Click an item below to jump to the field
                                </Typography>
                                <List dense disablePadding sx={{ maxHeight: 220, overflow: 'auto', width: '100%' }}>
                                    {Object.entries(errors).map(([fieldName, err]) => (
                                        <ListItemButton
                                            key={fieldName}
                                            onClick={() => scrollToField(fieldName)}
                                            sx={{
                                                width: '100%',
                                                borderRadius: 1,
                                                py: 0.75,
                                                px: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                '&:hover': { bgcolor: 'action.hover' }
                                            }}
                                            title='Click to jump to this field'
                                        >
                                            <ListItemIcon sx={{ minWidth: 24, mr: 1, color: 'inherit' }}>
                                                <Iconify icon='mdi:cursor-default-click' width={18} height={18} />
                                            </ListItemIcon>
                                            <ListItemText
                                                sx={{ flex: 1, pr: 1 }}
                                                primaryTypographyProps={{ sx: { fontSize: '0.875rem', lineHeight: 1.2 } }}
                                                secondaryTypographyProps={{ sx: { fontSize: '0.75rem', color: 'inherit' } }}
                                                primary={getFieldLabel(fieldName)}
                                                secondary={err?.message || 'Invalid value'}
                                            />
                                            <Box component='span' sx={{ width: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', ml: 1, opacity: 0.7 }}>
                                                <Iconify icon='mdi:chevron-right' width={18} height={18} />
                                            </Box>
                                        </ListItemButton>
                                    ))}
                                </List>
                            </Alert>
                        </Box>
                    )}
                </Card>
            </FormProvider>
        </Box>
    );
};

DefaultScriptView.propTypes = {
    onClose: PropTypes.func,
    scriptData: PropTypes.array,
    backButtonClick: PropTypes.func,
};

export default DefaultScriptView;
